import '../Tutorial.css';
import React, {useState} from 'react';
import TutorialGirl from "../TutorialGirl";
import Typewriter from "typewriter-effect";
import {useActions} from "../../../hooks/useActions";
import Hole from "../Hole";

function T35ShowRes() {
    const {setTutorial} = useActions();
    const [showNext, setShowNext] = useState(false);
    const atEnd = () =>{
        setShowNext(true);
    }


const text = 'In the battle, there are three types of mana resources: Fire, Air, and Earth.\n' +
    'On the left, you see the current amount of resources, and on the right, the growth per turn.'
    return (
        <div>

            <Hole className={'.playerResources'} diameter={320} />

            <div className='ShowRes35'>
            </div>


            <TutorialGirl position={'Right'}/>
            <div className='tutorialContainer tutorialTopContainerShoRes35'>
                <div className='tutorialBottomTextField'><Typewriter
                    options={{
                        delay: 30
                    }}
                    onInit={(typewriter) => {
                        typewriter.typeString(text).start().callFunction(atEnd);
                    }}
                /></div>
                {(showNext)?
                    <div className={'tutorialButton defaultButtonAnimation'} onClick={() => {
                        setTutorial({isActive: true, step: 'showRes37'});
                    }}>
                    </div>
                    : <div className={'tutorialButtonPlaceholder'}></div>
                }
            </div>
        </div>

    );
}

export default T35ShowRes;
